/**
 * Transform given from server data into dropdown options
 *
 * @returns An array of country and states options containing value (id) and label (name).
 */
export const getDevicesOptions = (devices: IDevice[] | undefined) => {
  if (!devices) return null;

  const devicesOptions = devices.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

  devicesOptions.unshift({ value: 0, label: "All devices" });

  return devicesOptions;
};
